<div class="resent-password-flow">
    <div class="resent-password-flow__blob resent-password-flow__blob--orange" aria-hidden="true"></div>
    <div class="resent-password-flow__blob resent-password-flow__blob--blue" aria-hidden="true"></div>
    <div class="resent-password-flow__blob resent-password-flow__blob--green" aria-hidden="true"></div>

    <div class="resent-password-flow__row">

        <img class="resent-password-flow__logo" src="./assets/images/logos/login-logo.png" alt="COMMITLY"/>

        <div class="resent-password-flow__card">
            <form class="resent-password-flow__form" [formGroup]="formGroup" (ngSubmit)="changePassword()">
                <button type="submit" hidden tabindex="-1" aria-hidden="true"></button>
                <p class="resent-password-flow__heading">{{'ResetPassword.Title' | translate}}</p>

                <ng-container *ngIf="!successMessage">
                    <div class="resent-password-flow__field">
                        <app-input-password
                            appAutofocus
                            data-test-id="resent-password-input"
                            [control]="newPassword"
                            [tabindex]="2"
                            [labelName]="'ResetPassword.Form.PasswordLabel' | translate"
                            [placeholder]="'ResetPassword.Form.PasswordPlaceholder' | translate"
                            [submitted]="submitPressed"
                        ></app-input-password>

                        <span class="resent-password-flow__error" *ngIf="submitPressed && newPassword.errors && newPassword.value">
                            {{'SignUp.Form.ErrorPasswordsFormat' | translate}}
                        </span>

                        <div class="resent-password-flow__error-summary" data-test-id="resent-password-error" *ngIf="errorMessage">
                            <span class="resent-password-flow__error">{{errorMessage | translate}}</span>
                        </div>
                    </div>

                    <ui-text-button [tabindex]="6" class="resent-password-flow__submit" [buttonStyle]="buttonStyle.Green"
                                    data-test-id="resent-password-submit"
                                    (click)="changePassword()"
                                    [disabled]="isSubmitting || (submitPressed && newPassword.invalid)">
                        {{'ResetPassword.Form.Submit' | translate}}
                    </ui-text-button>
                </ng-container>

                <div class="resent-password-flow__notice" data-test-id="resent-password-notice" *ngIf="successMessage">
                    {{successMessage | translate}}
                </div>
            </form>
        </div>

    </div>
</div>
